 
import MenuTop from "./MenuTop";
import MenuLeft from "./MenuLeft";
import BarBottom from "./BarBottom";

import Config from "../Config";

import { Fragment, useRef, useState } from "react";

import MyRoute from "../helpers/MyRoute";

import HomeView from "../modules/home/View";
import NewsView from "../modules/news/View";
import KidsView from "../modules/kids/View";
import EmpsView from "../modules/emp/View";
import CalcView from "../modules/invoice/View";
import MsgView from "../modules/msg/View";
import RaportView from "../modules/raport/View";
import MenView from "../modules/men/View";

import gomini from "../chat_mini.png";
import goleft from "../chat_left.png";
import goright from "../chat_right.png";
import gomax from "../chat_max.png";
import goclose from "../chat_close.png";
import gosend from "../gosend.png";
import goattach from "../goattach.png";
import InputUploaderAttach from "../helpers/InputUploaderAttach";
import AccessView from "../modules/access/View";
import { getNextKeyDef } from "@testing-library/user-event/dist/keyboard/getNextKeyDef";

import notice_mp3 from '../notice.mp3'
import notice_ogg from '../notice.ogg'
import WallImageBrowser from "../modules/news/WallImageBrowser";
import MediaBrowser from "../helpers/MediaBrowser";
import MediaLink from "../helpers/MediaLink";
 
import empty_user from "../empty_user.png";
import FormatDecimal from "../helpers/FormatDecimal";

import Start from "../modules/kids/Start";
import KidInfo from "../modules/raport/KidInfo";
import AppContext from "../AppContext";


function MainView(props)
{     
        var startModule = MyRoute( window.location.href, "module" );
        var startView = MyRoute( window.location.href, "view" );
        var startId = MyRoute( window.location.href, "id" );

        if(startModule == null || startModule == undefined) startModule = "kids";
        if(startView == null || startView == undefined) startView = "kid";
        if(startId == null || startId == undefined) startId = "-1";

        const [loc, setLoc] = useState({
            menuSelected: startModule,
            viewSelected: startView,
            startId: startId
        });

        const [menuVisible, setMenuVisible] = useState(1);

        const [globalVariable, setGlobalVariable]  = useState({           
        });

        var tmpGlobal = globalVariable;
        
             
        const [progressProc, setProressProc] = useState(-1);
        const [alertx, setAlertX] = useState(null);
        const [alertx_code, setAlertXCode] = useState('');
        const [alertx_crypt, setAlertXCrypt] = useState('');
        const [alertx_msg, setAlertXMsg] = useState('');

        const [dialogChat, setDialogChat] = useState([]);

        const [kidWindow, setKidWindow] = useState([]);

  

        const dialogChatWindow = [
            useRef(null),  useRef(null),  useRef(null),  useRef(null),  useRef(null),  useRef(null),  useRef(null),  useRef(null),  useRef(null),  useRef(null),  
            useRef(null),  useRef(null),  useRef(null),  useRef(null),  useRef(null),  useRef(null),  useRef(null),  useRef(null),  useRef(null),  useRef(null),  
            useRef(null),  useRef(null),  useRef(null),  useRef(null),  useRef(null),  useRef(null),  useRef(null),  useRef(null),  useRef(null),  useRef(null),  
        ];

        const audioRefer = useRef();
 

 
        const [preperListener, setPriperListener] = useState({
            status: 0,
            keyListeners: [],      
            refreshView: props.userData.refreshView 
        });
   

        var cssS = localStorage.getItem("style");
        if(cssS == undefined || cssS == null) 
        {
            cssS = 0;
            if(props.userData != undefined && props.userData.crm_style != undefined ) cssS = props.userData.crm_style;

            if(cssS != 0 && cssS != 1 && cssS != 2 && cssS != 3) cssS = 0;

        }
        const [cssStyle, setCssStyle] = useState(cssS);


        const codeChange = (e) => {
            var x = e.target.value;
            setAlertXCode(x);
        }



        const clickMenu = (item, item2, item3) => {



            
            sessionStorage.setItem("click-action-count", 0); //wyzeruj licznik zbyt duzej ilosci wywołań..
             

            console.log("clickMenu " + item + " " + item2 + " " + item3);

            setLoc( { ...loc , ["menuSelected"]:item, ["viewSelected"]:item2,["startId"]:item3  } );         


            //const url = new URL(window.location);
            //url.searchParams.set("foo", "bar");

            var url = "";
            if(item != undefined && item.length > 0) url = url + "/module/"+item;
            if(item2 != undefined && item2.length > 0) url = url + "/view/"+item2;
       //     window.history.pushState({}, "", url);     
            window.history.pushState({page: url}, "", url);  


            props.goRefresh(); 
            

            //scroll to Top webSite
            setTimeout( ()=> { 

                var rightContent = document.getElementsByClassName("econtent");
                if(rightContent.length > 0)
                {
                    console.log("goTop");             

                    window.scrollTo({
                        //'behavior': 'smooth',
                        'behavior': 'auto',
                        'left': 0,
                        'top': rightContent.offsetTop - 0
                      });

                }
                
            }, 200 );

        }        


        const quickGo = (e) => {

            
            var module = e.target.getAttribute("module");
            var view = e.target.getAttribute("view");
            var id = e.target.getAttribute("id");

            var mTop = e.target.getAttribute("mTop");

            if(module == null )
            {
                if(e.target.parentElement != null)
                {
                     module = e.target.parentElement.getAttribute("module");
                     view = e.target.parentElement.getAttribute("view");
                     id = e.target.parentElement.getAttribute("id");

                     console.log("XXX", e.target.parentElement );
                }
                
            }


            clickMenu(module,view,id);

            console.log("mtop", mTop, e.target, e.current);
            
            if( (mTop == undefined || mTop == null) && props.flagMobile == 1)
            {
                setMenuVisible(2); //zwin..
            }

            if(module == "men")
            {
                changeMenuStatus(0);
            }

            if(module == "home" && view == "start")
            {
                changeMenuStatus(1);
            }
        }


        window.addEventListener('beforeunload', function(e) {

                    console.log("mainView beforeunload ");
                    /*
                    var myPageIsDirty = true; //you implement this logic...
                    if(myPageIsDirty) {
                    //following two lines will cause the browser to ask the user if they
                    //want to leave. The text of this dialog is controlled by the browser.
                    e.preventDefault(); //per the standard
                    e.returnValue = ''; //required for Chrome
                    }
                    //else: user is allowed to leave without a warning dialog
                    */
                });


        window.onpopstate = function(event) {
           
            if(event){ 
              console.log("goBack or goNext" + event + " ," +window.location );
            }
            else{ 
              console.log("clickLink " + event + " ," + window.location);              
            } 


        

            var moduleX = MyRoute( window.location.href, "module" );               
            var viewX = MyRoute( window.location.href, "view" );
  
            setLoc({...loc, ["menuSelected"]:moduleX, ["viewSelected"]:viewX   });     
            props.goRefresh();      
          }



   

          if(preperListener.status == 0)
          {
                    setPriperListener({ ...preperListener, ["status"]:1 });

                    document.addEventListener("focus",function(e){
                  //      console.log("focus",e.target);
                    });

                    document.addEventListener("onblur",function(e){
                      //  console.log("onblur",e.target);
                    });

                    document.addEventListener("keydown",function(e){
                  
            
                        if(e.key === "Escape") {
                        
                            if(alertx != null && alertx.title.length > 1 ) //zamknij aktywny alert..
                            {
                                console.log("Escccc" );
                                setAlertX(null);  
                            }                             
                        }

                        
            
                     //   console.log("Key ", e.key, " AllListeners: ", preperListener.keyListeners.length);

            
                        for(var k=0; k<preperListener.keyListeners.length; k++)
                        {
                            if(preperListener.keyListeners[k].func != null && preperListener.keyListeners[k].func != undefined)
                            {
                                console.log( "Handle", preperListener.keyListeners[k].handle ,"Send key "+ e.key +" to " , preperListener.keyListeners[k].name );
            
                                preperListener.keyListeners[k].func(e.key);
                            }
                        }
                    
            
                    });

          }

         



        const showDialog = (title, msg, type, callback, param ) => {

            setAlertX(
                {
                    title: title,
                    msg: msg,
                    type:type,
                    callback: callback,
                    param: param,
                }
            );
        }  

     


        const closeDialog = (e) => {

            if(alertx.callback != null && alertx.callback != undefined && e != undefined)
            {
                var a = e.target.getAttribute('atr-type');
                alertx.callback(a);
            }

            if(alertx.callback != null && alertx.callback != undefined && e == undefined)
            {
                var a = 'ok';
                alertx.callback(a);
            }

            setAlertXMsg('');
            setAlertX(null);
        }



        const sendSMS = () => {

            console.log('Send SMS');
  
            setProressProc(-2);
            setAlertXMsg('Wysyłam...');
            setAlertXCode('');
            setAlertXCrypt('');
    
            fetch( Config.url + '/rest_v1,auth_send_sms', {
                method: 'POST', 
                body: JSON.stringify({
                    param: alertx.param
                }), 
                headers: {
                    'Content-Type': 'application/json',                    
                    'X-Api-Key': props.userData.apiKey,
                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                    '_sec_key_': Config.genXKey() ,
                }
             })
             .then(res => res.json() )
             .then(res => {             
                        
                        setProressProc(-1);
    
                        if(res._sys_ == undefined)
                        {
                            showDialog( "Error", "No correct response from server" , "ok" , null);  
                        }else
                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                        {
                           // props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);     
                           setAlertXMsg(res.result);                       
                        }else
                        if(res.status != undefined && res.status == "OK")
                        {
                            setAlertXMsg('Wysłano kod nr '+ res.result +' (poczekaj ok. 1 min.)');
                        }else
                        {                            
                            setAlertXMsg(res.result);
                        }
                       
             } )
             .catch(err => {   
                        setProressProc(-1);       
                        showDialog( "Error", "I: " + err , "ok" , null);
             });
                       
    
             return false;
    
        }
 

        const sendSMS_getcrypt = () => {

            console.log('Send SMS');
         

            if(alertx_code.length < 3)
                {
                    return;
                }
  
            setProressProc(-2);
            setAlertXMsg('Sprawdzam...');
     
    
            fetch( Config.url + '/rest_v1,auth_check_sms', {
                method: 'POST', 
                body: JSON.stringify({
                    sms: alertx_code
                }), 
                headers: {
                    'Content-Type': 'application/json',                    
                    'X-Api-Key': props.userData.apiKey,
                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                    '_sec_key_': Config.genXKey() ,
                }
             })
             .then(res => res.json() )
             .then(res => {             
                        
                        setProressProc(-1);
    
                        if(res._sys_ == undefined)
                        {
                            showDialog( "Error", "No correct response from server" , "ok" , null);  
                        }else
                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                        {
                           // props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                           setAlertXMsg(res.result);  
                           setAlertXCode(''); 
                           setAlertXCrypt('');
                        
                        }else
                        if(res.status != undefined && res.status == "OK")
                        {
                            setAlertXMsg('Kod prawidłowy');
                            setAlertXCrypt(res.result);
                            setAlertXCode('');  

                            alertx.callback(res.result);                        
                            setAlertX(null);

                        }else
                        {                            
                            setAlertXMsg(res.result);
                            setAlertXCode(''); 
                           setAlertXCrypt('');
                        }
                       
             } )
             .catch(err => {   
                        setProressProc(-1);       
                        showDialog( "Error", "I: " + err , "ok" , null);
             });
                       
    
             return false;
    
        }
 
        

        const writeFilter = (uq_name, val) => {

            var filterTab = {};        

            var tmp = sessionStorage.getItem("filter_tab");
            if(tmp != null && tmp != undefined)
                {               
                    filterTab = JSON.parse(tmp);                    
                }                                
     
             var newTab = {[uq_name]:val}   ;
             var dt = {...filterTab,...newTab};
                
             sessionStorage.setItem('filter_tab', JSON.stringify(dt) );

           // console.log("writeFilter", uq_name, val, dt);
        }
        
        const readFilter = (uq_name, def) => {

            var filterTab = [];

            var tmp = sessionStorage.getItem("filter_tab");
            if(tmp != null && tmp != undefined)
                {
                    filterTab = JSON.parse(tmp);
                }

            if(filterTab[uq_name] != null && filterTab[uq_name] != undefined )    
                {
                    var tx = filterTab[uq_name];
                    if(tx != undefined && tx != null) return tx;
                }

            return def;
        }



        const removeKeyListener = (  uqName ) => {


            for(var k=0; k<preperListener.keyListeners.length; k++)
                {
                    if(preperListener.keyListeners[k].name == uqName)
                    {
                        preperListener.keyListeners[k].func = null;        
                        
                        console.log("mainView, removeKeyListener", uqName );
                        return;
                    }
                }
        }



        const addKeyListener = ( handle,  uqName, func ) => {

            
            for(var k=0; k<preperListener.keyListeners.length; k++)
            {
                if(preperListener.keyListeners[k].name == uqName)
                {
                    preperListener.keyListeners[k].func = func;        
                    
                   // console.log("mainView, registerKeyListner - override ", uqName );
                    return;
                }
            }

           
                var kl =  {
                    handle: handle,
                    name: uqName,
                    func: func
                }
    
                preperListener.keyListeners.push(kl);
                console.log("mainView, registerKeyListner ", uqName );
           
      
        }


        const refreshHandle = ()  => {

            refreshChat(true);
        }


        //------------------------------------------------
        //------------------------------------------------

        const deleteMsg = (e) => {


            var id = e.target.getAttribute('atr-id');;

            setProressProc(-2);



            var row = {
               id: id,               
            }

            
            fetch( Config.master + '/rest_v1_msg,delete_chat_msg', {  //bo pliki sa wyslane do mastera..
                method: 'POST', 
                body: JSON.stringify(row), 
                headers: {
                    'Content-Type': 'application/json',                    
                    'X-Api-Key': props.userData.apiKey,
                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                    '_sec_key_': Config.genXKey() ,
                }
            })         
            .then(res => res.json() )
            .then(res => { 

                        setProressProc(-1);        
                        if(res._sys_ == undefined)
                        {
                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                        }else
                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                        {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                        }else    
                        {
                            setProressProc(-1);  
                            if(res.status == 'OK') {
                                 
                                 e.target.parentNode.innerHTML = "";

                            } 

                        }
            } )
            .catch(err => {          
                        showDialog( "Error", "I: " + err , "ok" , null);
                        setProressProc(-1);
            });

        }



        const sendChatMessage = (e) => {

                    var inx    = e.target.getAttribute("atr-inx");
                    var typ = "none";
                    var typId = -1;
                    var text_input  = "";

                    for(var k=0; k<dialogChat.length; k++)
                        {                          
                            if(k == inx)  
                            {
                                    typ = dialogChat[k].typ;
                                    typId = dialogChat[k].typId;
                                    text_input = dialogChat[k].text_input;
                                    break;
                            }         
                        }

                    if(typ == "none")     return;
                    if(text_input.length < 1) return;

                    setProressProc(-2);



                    var row = {
                       typ: typ,
                       typId: typId,
                       tresc: text_input, 
                    }

                    
                    fetch( Config.master + '/rest_v1_msg,send_chat_msg', {  //bo pliki sa wyslane do mastera..
                        method: 'POST', 
                        body: JSON.stringify(row), 
                        headers: {
                            'Content-Type': 'application/json',                    
                            'X-Api-Key': props.userData.apiKey,
                            '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                            '_p_dziecko_id_': props.userData.p_dziecko_id,
                            '_sec_key_': Config.genXKey() ,
                        }
                    })         
                    .then(res => res.json() )
                    .then(res => { 

                                setProressProc(-1);        
                                if(res._sys_ == undefined)
                                {
                                    props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                                }else
                                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                {
                                    props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                                }else    
                                {
                                    setProressProc(-1);  
                                    if(res.status == 'OK') {
                                          //

                                          for(var k=0; k<dialogChat.length; k++)
                                            {                          
                                                if(k == inx)  
                                                {
                                                    dialogChat[k].text_input = "";

                                                    setDialogChat( JSON.parse(JSON.stringify(dialogChat)) );

                                                    refreshChat(false);
                                                }         
                                            }
                                    } 

                                }
                    } )
                    .catch(err => {          
                                showDialog( "Error", "I: " + err , "ok" , null);
                                setProressProc(-1);
                    });



        }


        const openChat = (title, typ, typId)  => {                  
            dialogChat.push({
                status: 1, // 1 - okno otwarte, 2 - zminimalizowane
                title: title,
                typ: typ,
                typId: typId,
                text_input : "",
                text_dialog: [],
                lastId: -1,                                
            });          
            setDialogChat( [...dialogChat] );       
            refreshChat(false);     
        }


        const chatChange = (e) => {

            var option = e.target.getAttribute("atr-optionx");  //0 - usun 
            var inx    = e.target.getAttribute("atr-inx");

          //  var arr = new Array();  

            for(var k=0; k<dialogChat.length; k++)
                {
                  //  if(option == "0" && k == inx) continue; //usun nie dodawaj..

                    if(k == inx)   dialogChat[k].status = option;

                  //  arr.push( dialogChat[k] );
                }
            setDialogChat( [...dialogChat] );
        }


        const onChangeChatValEnter = (e) => {

            if(e.key == "Enter" )
            {
                    sendChatMessage(e);
                    return false;
            }
        }

        const onChangeChatVal = (e) => {

               var inx    = e.target.getAttribute("atr-inx");
               var val    = e.target.value;
 
 
               //var arr = new Array();  

               for(var k=0; k<dialogChat.length; k++)
                   {                        
                       if(k == inx)  
                       {
                         dialogChat[k].text_input = val;   
                       }
                     //  arr.push( dialogChat[k] );
                   }
   
   
               setDialogChat(  [...dialogChat]  );        
               goBottom(inx);
        }


        

        const completeUploadAttach = (fileName, crypt, param1, param2) => {


            console.log(fileName + " | " + crypt + " | " + param1 + " | " + param2);

            var inx    =    param1;   // e.target.getAttribute("atr-inx");
            var typ = "none";
            var typId = -1;
            var text_input  = "";

            for(var k=0; k<dialogChat.length; k++)
                {                          
                    if(k == inx)  
                    {
                            typ = dialogChat[k].typ;
                            typId = dialogChat[k].typId;
                            text_input = dialogChat[k].text_input;
                            break;
                    }         
                }

            text_input = "Załącznik";

            if(typ == "none")     return;
            if(text_input.length < 1) return;

            setProressProc(-2);



            var row = {
               typ: typ,
               typId: typId,
               tresc: text_input, 
               crypt: crypt,
            }

            
            fetch( Config.master + '/rest_v1_msg,send_chat_msg', {  //bo pliki sa wyslane do mastera..
                method: 'POST', 
                body: JSON.stringify(row), 
                headers: {
                    'Content-Type': 'application/json',                    
                    'X-Api-Key': props.userData.apiKey,
                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                    '_sec_key_': Config.genXKey() ,
                }
            })         
            .then(res => res.json() )
            .then(res => { 

                        setProressProc(-1);        
                        if(res._sys_ == undefined)
                        {
                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                        }else
                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                        {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                        }else    
                        {
                            setProressProc(-1);  
                            if(res.status == 'OK') {
                                  //

                                  for(var k=0; k<dialogChat.length; k++)
                                    {                          
                                        if(k == inx)  
                                        {
                                            dialogChat[k].text_input = "";

                                          //  setDialogChat( JSON.parse(JSON.stringify(dialogChat)) );
                                            setDialogChat( [...dialogChat]);

                                            refreshChat(false);
                                        }         
                                    }
                            } 

                        }
            } )
            .catch(err => {          
                        showDialog( "Error", "I: " + err , "ok" , null);
                        setProressProc(-1);
            });



        }


        const refreshChat =  (fromTimer) => {



            for(var actIndex=0 ; actIndex < dialogChat.length; actIndex++)
            { 
                if(    dialogChat[actIndex].status == 1 || dialogChat[actIndex].status == 2  )
                    {
                           
                                    var od_id = -1;

                                    if(dialogChat[actIndex].text_dialog.length > 0)
                                    {
                                        od_id = dialogChat[actIndex].text_dialog[0].id;
                                    }
                           
                                    var row = {
                                        typ: dialogChat[actIndex].typ,
                                        typId:  dialogChat[actIndex].typId,        
                                        od_id: od_id,                 
                                    }
        
                                    
                                    fetch( Config.master + '/rest_v1_msg,recv_chat_msg', {  //bo pliki sa wyslane do mastera..
                                        method: 'POST', 
                                        body: JSON.stringify(row), 
                                        headers: {
                                            'Content-Type': 'application/json',                    
                                            'X-Api-Key': props.userData.apiKey,
                                            '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                                            '_p_dziecko_id_': props.userData.p_dziecko_id,
                                            '_sec_key_': Config.genXKey() ,
                                        }
                                    })         
                                    .then(res => res.json() )
                                    .then(res => { 
        
                                             
                                                if(res._sys_ == undefined)
                                                {
                                                    props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                                                }else
                                                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                                {
                                                    props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                                                }else    
                                                {
                                               
                                                    if(res.status == 'OK' ) {
                                                         

                                                        var xTyp   = res.result.typ;
                                                        var xTypId = res.result.typId;
                                                        var xRows = res.result.rows;

                                               
                                                        var addedNew = false;

                                                        for(var w=0; w<dialogChat.length; w++)
                                                        {
                                                            if(  ( dialogChat[w].status == 1 || dialogChat[w].status == 2 )  &&  dialogChat[w].typ == xTyp && dialogChat[w].typId == xTypId &&  xRows.length > 0 )  
                                                            {
                                                                   

                                                                var tmp = [...dialogChat[w].text_dialog];


                                                                dialogChat[w].text_dialog = new Array();

                                                                for(var mx=0; mx<xRows.length; mx++)
                                                                {
                                                                    dialogChat[w].text_dialog.push(xRows[mx]); 

                                                                    if(xRows[mx].wlasciciel == 0) addedNew = true;

                                                                }

                                                                for(var xt =0; xt<tmp.length; xt++)
                                                                {
                                                                    dialogChat[w].text_dialog.push( tmp[xt] );   
                                                                }

                                                                setDialogChat( [...dialogChat] );

                                                                setTimeout( () => {
                                                                    console.log("gtobottom", w)
                                                                    goBottom(w)
                                                                } , 200 );                                                                                                                             

                                                             
                                                                break;
                                                            }
                                                        }

                                                        if(addedNew && fromTimer)
                                                        {
                                                            playNotice("Nowa wiadomość");
                                                        }

                                                    } 
        
                                                }
                                    } )
                                    .catch(err => {          
                                                showDialog( "Error", "I: " + err , "ok" , null);
                                              
                                    });
        
        
        
                    }
           

            }

         

         
 


        }


        const playNotice = (title)  => {

            if(title.length > 0 )
            {
                    var tmpTitle = document.title;

                    document.title = title;
        
                    setTimeout( ()=>{
                        document.title = tmpTitle
                    }, 500 );
        
                    setTimeout( ()=>{
                        document.title = title
                    }, 1000 );
        
                    setTimeout( ()=>{
                        document.title = tmpTitle
                    }, 1500 );
            }

            audioRefer.current.play();
             

        }


        const goBottom = (inx) => {
    
            if(dialogChatWindow[inx] == undefined || dialogChatWindow[inx] == null )
            {
                 console.log("goBottom, no object (0x9834), " , inx, dialogChatWindow[inx]);
                 return;
            }

            var element = dialogChatWindow[inx].current;

            if(element == null || element == undefined) 
            {
                console.log("goBottom, no object, " , inx, dialogChatWindow[inx]);
                return;
            }


            //console.log("goBottom", element.scrollTop , element.scrollHeight);

            element.scrollTop = element.scrollHeight;
           
        }


        //------------------------------------------------
    
        function isMobile() {
            const userAgent = navigator.userAgent;
            return /Android|iPhone|iPad|Windows Phone/i.test(userAgent);
        }

        //------------------------------------------------


        const openKid = (id, name, last_name )  => {                  
 
            //sprawdz czy juz otwarte..
            for(var w=0; w < kidWindow.length ; w++)
            {
                if(kidWindow[w].id == id)
                {
                    kidWindow[w].status = 1; //pokaz ponownie
                    setKidWindow( [...kidWindow] );
                    return;
                }
            }




            setProressProc(-2);


            var row = {
               id: id,               
            }
            
            fetch( Config.url + '/rest_v1_kids,review', {  
                method: 'POST', 
                body: JSON.stringify(row), 
                headers: {
                    'Content-Type': 'application/json',                    
                    'X-Api-Key': props.userData.apiKey,
                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                    '_sec_key_': Config.genXKey() ,
                }
            })         
            .then(res => res.json() )
            .then(res => { 

                        setProressProc(-1);    

                        if(res._sys_ == undefined)
                        {
                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                        }else
                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                        {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                        }else    
                        {
                            setProressProc(-1);  
                            if(res.status == 'OK') {
                                 
                                

                                kidWindow.push({
                                    status: 1, // 1 - okno otwarte, 2 - zminimalizowane
                                    id: id, 
                                    name: name,                                           
                                    last_name: last_name,                                           
                                    result: res.result,
                                });          
                                setKidWindow( [...kidWindow] );   

                            } 

                        }
            } )
            .catch(err => {          
                        showDialog( "Error", "I: " + err , "ok" , null);
                        setProressProc(-1);
            });

 

        }

        const kidSetPosition = (e) => {

            var inx    = e.target.getAttribute("atr-inx");

            for(var k=0; k<kidWindow.length; k++)
                {
                    //  if(option == "0" && k == inx) continue; //usun nie dodawaj..
                    kidWindow[k].status = "2";
                    if(k == inx )  kidWindow[k].status = "1"
                    //  arr.push( dialogChat[k] );
                }
            setKidWindow( [...kidWindow] );

        }

        
        const kidChange = (e) => {

            var option = e.target.getAttribute("atr-optionx");  //0 - usun 
            var inx    = e.target.getAttribute("atr-inx");

            var arr = new Array();  
    

            for(var k=0; k<kidWindow.length; k++)
                {
                    if(option == "0" && k == inx) continue; //usun nie dodawaj..

                    if(k == inx)   kidWindow[k].status = option;

                    arr.push( kidWindow[k] );
                }
            setKidWindow(  arr );
        }
            

        //------------------------------------------------        
    
        const changeMenuStatus = (visible) => {
            setMenuVisible(visible);
        }

      //  console.log("AAAABCCCDDD");

        const setProgressAndCountClick = (proc) =>{

            setTimeout(  ()=>{
                setProressProc(proc);
            } ,100 );
             
            
            if(proc == -2)
            {
                    var c = sessionStorage.getItem("click-action-count");

                    if(c == undefined || c == null)
                    {
                        c = 0;
                    }

                    c++;


                    if( c > 1500 )
                    {
                        props.logout();
                        //window.location.reload();
                        window.location.href = "https://app.elizak.edu.pl?to-much-redirect=true";
                    }
                    //console.log("click-action ", c);

                    sessionStorage.setItem("click-action-count", c);
            }
        }



        //-----------------------------------------------
        //zmienne globalne

        const setGlobal = (vName, vValue) => {
                    
            if(vName == '_x_')
            {
               
                setGlobalVariable(  vValue );                
            }else
            {
                setGlobalVariable(  {  ...globalVariable, [vName]:vValue } );                       
            }
        }
          
        const getGlobal = (vName) => { 

            if(vName == '_x_') return globalVariable;

            return globalVariable[vName];
        }                      
        //------------------------------------------------        

        const setStyle = (num) => {

                localStorage.setItem("style", num);
                setCssStyle(num);


                var dt = { 
                    'crm_style': num,                  
                 }


                fetch( Config.url + '/rest_v1,up_style', {
                    method: 'POST', 
                    body: JSON.stringify(dt), 
                    headers: {
                        'Content-Type': 'text/html',
                        'X-API-KEY': props.userData.apiKey,
                        '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                        '_p_dziecko_id_': props.userData.p_dziecko_id,
                        '_sec_key_': Config.genXKey() ,
                    }
                })
                .then(res => res.json() )
                .then(res => {                                           
                
                    
                        //
                    
                } )
                .catch(err => {
                    console.log("Err " + err);
                }); 

                //
        }



        var mainView = {   
           
            menuSelected: loc.menuSelected,
            viewSelected: loc.viewSelected,
            idSelected: loc.startId,
            menuVisible: menuVisible,
            changeMenuStatus: changeMenuStatus,
            clickMenu: clickMenu,
            quickGo: quickGo, 
            changeProfile: props.changeProfile,
            changeLang: props.changeLang,
            logout: props.logout,
            showDialog: showDialog,
            setProgress: setProgressAndCountClick,
            readFilter: readFilter,
            writeFilter:writeFilter,
            addKeyListener: addKeyListener,
            removeKeyListener: removeKeyListener,
            openChat: openChat,
            openKid: openKid,
            refreshHandle: refreshHandle,  //przychodzi sygnało od Menu Top,
            setGlobal: setGlobal,
            getGlobal: getGlobal,
            setStyle: setStyle,
            isMobile: isMobile,
        };
 


       
        if(globalVariable["lock"] != null && globalVariable["lock"] != undefined  )
        {
            if(globalVariable["lock"] == 1 &&  loc.viewSelected != 'pay')
            {               
                clickMenu('home','pay','-1');

                showDialog( "Ups!", globalVariable["lock_reason"]   , "ok" ,  (param) => {

                        //document.location.href="/module/home/view/pay";                       
                 } );  
            }
        }



        var content = "Wybierz opcje z menu";        
        

        switch(loc.menuSelected)
        {
            case 'home': 
            {
                content = <HomeView userData={props.userData} mainView={mainView}   />
            }break;

            case 'news': 
            {
                content = <NewsView userData={props.userData}  mainView={mainView}  />
            }break;

            case 'kids': 
            {
                content = <KidsView userData={props.userData}  mainView={mainView}  />
            }break;

            case 'emps': 
            {
                content = <EmpsView userData={props.userData}  mainView={mainView}  />
            }break;


            case 'calc': 
            {
                content = <CalcView userData={props.userData}  mainView={mainView}  />
            }break;
            

            case 'msg': 
            {
                content = <MsgView userData={props.userData}  mainView={mainView}  />              
            }break;

            case 'raport': 
            {
                content = <RaportView userData={props.userData}  mainView={mainView}  />              
            }break;

            case 'access': 
            {
                content = <AccessView userData={props.userData}  mainView={mainView}  />                
            }break;
            
            case 'men': 
            {
                content = <MenView userData={props.userData}  mainView={mainView}  />                
            }break;

            default: {
                content = <NewsView userData={props.userData}  mainView={mainView}  />
            }
        }

        //---------------------------------
     
   
        var dialog = null;
    

        if(alertx != null && alertx.title.length > 0 && alertx.type == "ok" )
        {
            /*
            dialog = <div className="dlg_window shadowx">
                       <div className="dlg_title">{alertx.title}</div>
                       <div className="dlg_msg">{alertx.msg}</div>
                       <div className="dlg_btn">
                          <div className="btn" atr-type="ok" onClick={closeDialog}> {props.userData.dic.dlg_ok}</div>
                       </div>
            </div>;
            */

             dialog = <div className="dlg_push">
                       <div className="dlg_push_title">{alertx.title}</div>
                       <div className="dlg_push_msg">{alertx.msg}</div>
                       <div className="dlg_push_btn">
                          <div className="dlg_push_btn" atr-type="ok" onClick={closeDialog}> {props.userData.dic.dlg_ok}</div>
                       </div>
             </div>;

             setTimeout(() => {
                    closeDialog();
             }, 4000);
        }

           



        if(alertx != null && alertx.title.length > 0 && alertx.type == "yesno" )
        {
            dialog = <div className="dlg_window shadowx">
                       <div className="dlg_title">{alertx.title}</div>
                       <div className="dlg_msg">{alertx.msg}</div>
                       <div className="dlg_btn">
                          <div className="btn" atr-type="yes" onClick={closeDialog}> {props.userData.dic.dlg_yes}</div>
                          &nbsp; &nbsp;
                          <div className="btn" atr-type="no" onClick={closeDialog}> {props.userData.dic.dlg_no}</div>
                       </div>
            </div>;
        }


        if(alertx != null && alertx.title.length > 0 && alertx.type == "auth" )
            {
                dialog = <div className="dlg_window dlg_window_auth shadowx">
                           <div className="dlg_title">{alertx.title}</div>
                           <div className="dlg_msg">{alertx.msg}</div>
                           <div className="dlg_msg">
                                  <input type="text" value={alertx_code} onChange={codeChange} placeholder="*Kod SMS: " />  
                                  &nbsp;
                                  <sup className="link_color" onClick={sendSMS}>wyślij kod</sup>
                           </div>
                           <div className="dlg_msg">{alertx_msg}</div>                           
                           <div className="dlg_btn">
                              <div className="btn" atr-type="yes"  onClick={sendSMS_getcrypt} >Wykonaj</div>
                              &nbsp; &nbsp;
                              <div className="btn" atr-type="no" onClick={closeDialog}>Anuluj</div>
                           </div>
                           <div className="dlg_short_info">*Operacje możesz potwierdzić ostatnim otrzymanym kodem SMS<br/>jeśli data ważności nie uległa przedawnieniu. </div>
                </div>;
            }


    
        if(props.userData == undefined || props.userData == null )
        {
                mainView.logout();
                return (
                    <div>...</div>
                )
        }


        if(props.userData.pl == undefined)
                {
                    mainView.logout();
                    return (
                        <div>...</div>
                    )
        }            



        var cssX = "";
        if(menuVisible == 0) cssX = "full_screen";

        if(cssStyle == 0)
        {
            cssX = cssX + " styleGreen "; //def..
        }

        if(cssStyle == 1)
        {
                cssX = cssX + " styleGreen ";
        }

        if(cssStyle == 2)
        {
                    cssX = cssX + " styleWhite ";
        }






        console.log("MainView render");




        return (
            <div className={ "elizak " + cssX}>              

      
                  <MenuTop   userData={props.userData}  mainView={mainView}  />                                      
                  <MenuLeft  userData={props.userData}  mainView={mainView}/>                                    

 
                  {content} 

                  {dialog}
         
                  
                  <BarBottom progress={progressProc} />

                
                  <audio  ref={audioRefer}>
                        <source src={notice_ogg} type="audio/ogg" />
                        <source src={notice_mp3} type="audio/mpeg" />                       
                  </audio>



                <div className="kids_preview">
                    
                        {
                            kidWindow.map( (vKid, ix) => {
                               

                                if(vKid.status == "1")
                                    {
                                        return <div className="kids_preview_window shadowy"  atr-move="0" onMouseDown={AppContext.dialogOnMouseDown} onMouseUp={AppContext.dialogOnMouseUp}   onMouseOver={AppContext.dialogOnMouseUp}  onMouseMove={AppContext.dialogOnMouseMove} onMouseOut={AppContext.dialogOnMouseUp}   >
                                                <div className="kids_preview_title">
                                                        <img   atr-inx={ix} atr-optionx="0" onClick={kidChange}   src={goclose} class="link_color" title="Zamknij"  />

                                                        {
                                                            ix > 0 &&
                                                            <img   atr-inx={ix-1}  onClick={kidSetPosition}  src={goleft} class="link_color" title={"Idź do " + kidWindow[ix-1].result.imie + " " + kidWindow[ix-1].result.nazwisko   }  />     
                                                        }

                                                        <img   atr-inx={ix} atr-optionx="2" onClick={kidChange}  src={gomini} class="link_color" title="Zminimalizuj" />                                                       
                                                          
                                                        {
                                                            ix < kidWindow.length-1 &&
                                                            <img   atr-inx={ix+1} atr-optionx="2" onClick={kidSetPosition}  src={goright} class="link_color" title={"Idź do " + kidWindow[ix+1].result.imie + " " + kidWindow[ix+1].result.nazwisko   }  />   
                                                        }
                                                        
                                                        &nbsp;&nbsp;
                                                        {vKid.last_name + " " + vKid.name}
                                                </div>                                                                                     

                                                <div className="kids_preview_content">
                                                        <table className="table_preview">


                                                           <tr>
                                                                        <td colSpan={4} className="labT labBold">Dziecko</td>
                                                            </tr>

                                                            <tr>
                                                                <td className="labT" >Imię i nazwisko</td>
                                                                <td>{vKid.result.imie + " " + vKid.result.nazwisko}</td>
                                                                <td className="labT">Data / miejsce urodzenia</td>
                                                                <td>{vKid.result.data_urodzenia} / {vKid.result.miejsce_urodzenia} </td>
                                                            </tr>
 

                                                            <tr>
                                                                <td className="labT">Pesel</td>
                                                                <td>{vKid.result.pesel}</td>
                                                                <td className="labT">&nbsp;</td>
                                                                <td>&nbsp;</td>
                                                            </tr>

                                                            <tr>
                                                                <td className="labT">Adres</td>
                                                                <td>{vKid.result.adres}</td>
                                                                <td className="labT">Adres kors.</td>
                                                                <td>{vKid.result.adres_kor}</td>
                                                            </tr>

                                                            {
                                                                vKid.result.rodzice.length > 0 && 1 == 2 &&
                                                                <Fragment>

                                                                    <tr>
                                                                        <td colSpan={4} className="labT labBold">1. Rodzic / Opiekun</td>
                                                                    </tr>

                                                                    <tr>
                                                                        <td className="labT">Imie i nazwisko</td>
                                                                        <td>{ vKid.result.rodzice[0].imie + " " + vKid.result.rodzice[0].nazwisko }</td>
                                                                        <td className="labT">Tel. / E-mail</td>
                                                                        <td>{ vKid.result.rodzice[0].telefon_kontaktowy + " / " + vKid.result.rodzice[0].e_mail_kontakt }</td>
                                                                    </tr>

                                                                    <tr>
                                                                        <td className="labT">Pesel</td>
                                                                        <td>{ vKid.result.rodzice[0].pesel}</td>
                                                                        <td className="labT">Nr dowodu</td>
                                                                        <td>{ vKid.result.rodzice[0].nr_dowodu  }</td>
                                                                    </tr>

                                                                </Fragment>
                                                            }

                                                            {
                                                                vKid.result.rodzice.length > 1 && 1 == 2 &&
                                                                <Fragment>

                                                                    <tr>
                                                                        <td colSpan={4} className="labT labBold">2. Rodzic / Opiekun</td>
                                                                    </tr>

                                                                    <tr>
                                                                        <td className="labT">Imie i nazwisko</td>
                                                                        <td>{ vKid.result.rodzice[1].imie + " " + vKid.result.rodzice[1].nazwisko }</td>
                                                                        <td className="labT">Tel. / E-mail</td>
                                                                        <td>{ vKid.result.rodzice[1].telefon_kontaktowy + " / " + vKid.result.rodzice[1].e_mail_kontakt }</td>
                                                                    </tr>

                                                                    <tr>
                                                                        <td className="labT">Pesel</td>
                                                                        <td>{ vKid.result.rodzice[1].pesel}</td>
                                                                        <td className="labT">Nr dowodu</td>
                                                                        <td>{ vKid.result.rodzice[1].nr_dowodu  }</td>
                                                                    </tr>

                                                                </Fragment>
                                                            }


                                                            {
                                                                vKid.result.umowy.length > 0 &&
                                                                <Fragment>
                                                                    
                                                                    <tr>
                                                                        <td colSpan={4} className="labT labBold">Umowy</td>
                                                                    </tr>

                                                                    {
                                                                       vKid.result.umowy.map( (um, iUm) => {

                                                                        return <Fragment>

                                                                                    <tr>
                                                                                        <td className="labT">Numer</td>
                                                                                        <td>{ um.numer_umowy}</td>
                                                                                        <td className="labT">Data zawarcia</td>
                                                                                        <td>{ um.data_zawarcia  }</td>
                                                                                    </tr>

                                                                                    <tr>
                                                                                        <td className="labT">Stawki</td>
                                                                                        <td colSpan={3}>
                                                                                            
                                                                                                {
                                                                                                    um.stawki.map( (st,stInx) => {
                                                                                                        return <div>                                                                                                                                                                                                                          
                                                                                                              {st.nazwa} ,

                                                                                                              <FormatDecimal value={st.kwota_netto} />
                                                                                                        </div>
                                                                                                    } )
                                                                                                }
                                                                                            
                                                                                        </td>
                                                                                        
                                                                                    </tr>
                                                                        </Fragment>

                                                                      

                                                                       } ) 
                                                                    }
  

                                                                </Fragment>
                                                            }
                                                            

                                                        </table>

                                                        <div className="kids_preview_content_sub">
                                                                <Start  userData={props.userData}  mainView={mainView}  p_dziecko_id={vKid.id}  head={false} /> 
                                                        </div>

                                                        <div className="kids_preview_content_sub">
                                                                <KidInfo  userData={props.userData}  mainView={mainView}  p_dziecko_id={vKid.id}  head={false} /> 
                                                        </div>
                                                </div>

                                        </div>
                                    }
 
                                if(vKid.status == "2")
                                    {
                                        return <div className="kids_preview_item shadowx"  atr-move="0" onMouseDown={AppContext.dialogOnMouseDown} onMouseUp={AppContext.dialogOnMouseUp}   onMouseMove={AppContext.dialogOnMouseMove} onMouseOut={AppContext.dialogOnMouseUp}    >
                                                <div className="kids_preview_title">
                                                        <img   atr-inx={ix} atr-optionx="1" onClick={kidChange}   src={gomax} class="link_color" title="Pokaż"  />
                                                        <img   atr-inx={ix} atr-optionx="0" onClick={kidChange}  src={goclose} class="link_color" title="Zamknij" />                                                        
                                                        {vKid.last_name + " " + vKid.name}
                                                </div>                                                                                     
                                        </div>
                                    }
                            } )
                        }

                </div>

                 
                  <div className="dialog_chat">
                   
                  


                        {
                            dialogChat.map( (chat, ix) => {

                                    if(chat.status == "1")
                                    {

                                      
                                   

                                        return <div className="dialog_chat_item shadowx" >
                                                <div className="dialog_chat_title">

                                                       <div className="g_left">
                                                            {chat.title}
                                                       </div>

                                                       <div className="g_right">                                                         
                                                            <img   atr-inx={ix} atr-optionx="2" onClick={chatChange}   src={gomini} class="link_color" title="Zminimalizuj"  />                                                     
                                                            <img   atr-inx={ix} atr-optionx="0" onClick={chatChange}  src={goclose} class="link_color" title="Zamknij" />
                                                       </div>
                                                    
                                                                                                         
                                                </div>
                                                <div className="dialog_chat_content">
                                                    <div className="chat_scroll" ref={ dialogChatWindow[ix]}>

                                                        
                                                        {
                                                           
                                                           [...chat.text_dialog].reverse().map(  (row, irow) => {

                                                                    if(row.wlasciciel == 1)
                                                                    {
                                                                        var aw = empty_user;
                                                                                            
                                                                        if( row.nadawca.awatar != null &&  row.nadawca.awatar.length > 10)
                                                                        {
                                                                                aw = "data:image/png;base64," + row.nadawca.awatar;
                                                                        }


                                                                        return <div className="dlg_chat_item dlg_right">                                                                                
                                                                               <div className="dlg_chat_nd">{row.nadawca.nazwa} <img src={aw} /> </div>
                                                                               <div className="dlg_chat_cc">{row.czas}</div>
                                                                               <br/>
                                                                               <div className="dlg_chat_txt">{row.tresc}</div>
                                                                               <br/>
                                                                               <sup className="link_color" atr-id={row.id} onClick={deleteMsg} >usuń</sup> 
                                                                               <br/>
                                                                                <div className="dlg_attach">
                                                                                {
                                                                                    row.zalaczniki.map( ( zal, inxZal) => {

                                                                                        if( ( zal.typ_pliku=='png' ||  zal.typ_pliku=='jpg' ||  zal.typ_pliku=='jpeg' ||  zal.typ_pliku=='mp4' ) && zal.b64.length > 1 || zal.vid.length > 1 )
                                                                                            {
                                                                                                return <MediaBrowser userData={props.userData} mainView={mainView}  review={zal.b64} typ="p_wiadomosci" typId={row.id} />
                                                                                            }else
                                                                                            {
                                                                                                return <div>
                                                                                                    
                                                                                                       <MediaLink userData={props.userData} mainView={mainView} title={zal.nazwa} link={ Config.url + "/api,image,secure," + zal.api_unique} />  
                                                                                                       <br/>&nbsp; <br/>
                                                                                                </div>
                                                                                            
                                                                                            }
                                                                                    } )
                                                                                }
                                                                                </div>

                                                                          </div>
                                                                    }

                                                                    if(row.wlasciciel == 0)
                                                                    {
                                                                                var aw = empty_user;
                                                                                            
                                                                                if( row.nadawca.awatar != null &&  row.nadawca.awatar.length > 10)
                                                                                {
                                                                                        aw = "data:image/png;base64," + row.nadawca.awatar;
                                                                                }

                                                                            return <div className="dlg_chat_item dlg_left">                                                                                
                                                                                   <div className="dlg_chat_nd"> <img src={aw} /> {row.nadawca.nazwa}</div>
                                                                                   <div className="dlg_chat_cc">{row.czas}</div>
                                                                                   <br/>
                                                                                   <div className="dlg_chat_txt">{row.tresc}</div>
                                                                                   <br/>
                                                                                   <div className="dlg_attach">
                                                                                {
                                                                                    row.zalaczniki.map( ( zal, inxZal) => {

                                                                                        if( ( zal.typ_pliku=='png' ||  zal.typ_pliku=='jpg' ||  zal.typ_pliku=='jpeg' ||  zal.typ_pliku=='mp4' ) && zal.b64.length > 1 || zal.vid.length > 1 )
                                                                                            {
                                                                                                return <MediaBrowser userData={props.userData} mainView={mainView}  review={zal.b64} typ="p_wiadomosci" typId={row.id} />
                                                                                            }else
                                                                                            {
                                                                                                return <div>                                                                                                
                                                                                                    <MediaLink userData={props.userData} mainView={mainView} title={zal.nazwa} link={ Config.url + "/api,image,secure," + zal.api_unique} />  
                                                                                                    <br/>&nbsp; <br/>
                                                                                                </div>
                                                                                            }
                                                                                    } )
                                                                                }
                                                                                </div>
                                                                              </div>
                                                                    }

                                                            }  ) 
                                                        }

                                                    </div>
                                                    <div className="chat_input">
                                                        <textarea value={chat.text_input} className="chat_area" onChange={onChangeChatVal} onKeyDown={onChangeChatValEnter} atr-inx={ix} placeholder="Napisz coś...">
                                                        </textarea>
                                                        <div className="chat_btn">
                                                            <img      src={gosend} class="link_color" title="Pokaż" atr-inx={ix}   onClick={sendChatMessage} />                                                            
                                                      

                                                            <InputUploaderAttach   userData={props.userData}  param1={ix} param2={""}  completeUpload={completeUploadAttach} title={ "-dodaj załącznik-" } max_files="10" ext="*/*" />                    
                                         
                                                        </div>
                                                    </div>
                                                </div>                                    
                                        </div>
                                    }

                                    if(chat.status == "2")
                                        {
                                            return <div className="dialog_chat_item shadowx">
                                                    <div className="dialog_chat_title">
                                                            <img   atr-inx={ix} atr-optionx="0" onClick={chatChange}  src={goclose} class="link_color" title="Zamknij" />
                                                            <img   atr-inx={ix} atr-optionx="1" onClick={chatChange}   src={gomax} class="link_color" title="Pokaż"  />
                                                            {chat.title}
                                                    </div>                                                                                     
                                            </div>
                                        }
                                   


                            } )                    
                        }
                  </div>  


            </div>
        )
}


export default MainView;